"use server";
// Every change to the board from the page goes through here: the work is in lib/ops.ts (shared with the
// command line), these wrappers re-render the page afterwards. No login yet: one user.
import { refresh } from "next/cache";
import * as ops from "@/lib/ops.ts";
import type { Kind } from "@/lib/types.ts";

function done<T>(v: T): T {
  refresh();
  return v;
}

export async function saveGoal(input: ops.GoalInput) {
  return done(ops.saveGoal(input));
}
export async function saveMeasure(input: ops.MeasureInput) {
  return done(ops.saveMeasure(input));
}
export async function saveRequirement(input: ops.RequirementInput) {
  return done(ops.saveRequirement(input));
}
export async function saveCriterion(input: ops.CriterionInput) {
  return done(ops.saveCriterion(input));
}
export async function saveFeature(input: ops.FeatureInput) {
  return done(ops.saveFeature(input));
}
export async function saveQuestion(input: ops.QuestionInput) {
  return done(ops.saveQuestion(input));
}
export async function deleteEntry(kind: Kind, id: number) {
  return done(ops.deleteEntry(kind, id));
}

/** Shift-click on the board. Refusals come back as a message: a thrown one is hidden in a production build. */
export async function toggleLink(
  a: { kind: Kind; id: number },
  b: { kind: Kind; id: number },
): Promise<{ ok: true; result: ops.LinkResult } | { ok: false; message: string }> {
  try {
    return done({ ok: true as const, result: ops.toggleLink(a, b) });
  } catch (err) {
    return { ok: false, message: err instanceof Error ? err.message : String(err) };
  }
}
